import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import _ from 'lodash';
import template from '../../../templates/FeatureInclusion/FeatureSelection/Index.rt';
import featureSelectionHeader from '../../../templates/FeatureInclusion/Header.rt';
import featureSelectionSubHeader from '../../../templates/FeatureInclusion/FeatureSelection/SubHeader.rt';
import featureSelectionFooter from '../../../templates/PageLayout/GenericFooter.rt';
import * as actions from '../../../actions';
import * as Misc from '../../../misc';

const namify = (featureName) => {
  var nameParts = featureName.split('-');
  for(var n = 0; n < nameParts.length; n++) {
    nameParts[n] = _.trim(nameParts[n]);
  }
  return nameParts;
}

function mapStateToProps(state, props) {
  const PAGE_LENGTH = 25;
  const {featureInclusionData, selectedPreset, featureList} = state.featureInclusion;
  const { page, checkedFeatureGroups, selectedFeatureGroup, checkedFeatures, searchTerm } = state.featureInclusion.featureSelection;
  let presetIndex = _.findIndex(featureInclusionData, (fid) => { return fid.id == selectedPreset; });
  let preset = featureInclusionData[presetIndex];

  let featureGroups = [];
  for(var i = 0; i < featureList.length; i++) {
    let feature = featureList[i]
      , nameSplit = namify(feature.name)
      , group = nameSplit[0]
      , index = _.findIndex(featureGroups, (fg) => { return fg.toLowerCase() == group.toLowerCase(); });
    if(index < 0 && nameSplit.length > 1) {
      featureGroups.push(group);
    }
  }
  featureGroups.sort();

  let activeFeatureGroup = selectedFeatureGroup;
/*  if(!activeFeatureGroup && featureGroups.length > 0) {
    activeFeatureGroup = featureGroups[0];
  }*/

  let visibleFeatures = featureList.filter(f => {
    let featureName = f.name.split('-')
      , name = _.trim(featureName[0]).toLowerCase();
      return _.trim(activeFeatureGroup).toLowerCase() == name;
  });

  if(searchTerm && _.trim(searchTerm).length > 0) {
    visibleFeatures = visibleFeatures.filter((d) => {
      return _.includes(d.name.toLowerCase(), _.trim(searchTerm).toLowerCase());
    });
  }

  visibleFeatures.sort((a,b) => {
    let aName = _.trim(a.name).toLowerCase()
      , bName = _.trim(b.name).toLowerCase();
    if(aName < bName) {
      return 1;
    } else if(aName > bName) {
      return -1;
    }
    return 0;
  });

  let pagedVisibleFeatures = _.chunk(visibleFeatures, PAGE_LENGTH)[page];
  let totalPages = Math.ceil((visibleFeatures || []).length / PAGE_LENGTH);

  return {
    featureInclusionData,
    totalPages,
    page,
    selectedPreset: preset,
    featureGroups,
    checkedFeatureGroups,
    features: pagedVisibleFeatures || [],
    selectedFeatureGroup: activeFeatureGroup,
    checkedFeatures
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    loadPresets: () => dispatch(actions.featureInclusion.loadPresets()),
    toggleFeatureGroup: (featureGroup) => dispatch(actions.featureInclusion.toggleFeatureGroup(featureGroup)),
    selectFeatureGroup: (featureGroup) => dispatch(actions.featureInclusion.selectFeatureGroup(featureGroup)),
    checkFeature: (featureId) => dispatch(actions.featureInclusion.selectFeature(featureId)),
    setSearchTerm: (term) => dispatch(actions.featureInclusion.setFeatureSearchTerm(term)),
    setPage: (page) => dispatch(actions.featureInclusion.setFeaturePage(page)),
    handleCancelClick: () => hashHistory.push('/featureInclusion'),
    handleSaveClick: () => dispatch(actions.featureInclusion.saveFeatureSelection())
  };
}

class featureSelection extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    if(!this.props.selectedPreset) {
      hashHistory.push('/featureInclusion');
    } else if(this.props.featureInclusionData.length == 0) {
      this.props.loadPresets();
    }
  }
  render = template;

  isGroupChecked = (group) => {
    return this.props.checkedFeatureGroups.indexOf(group) > -1;
  }

  selectFeatureGroup = (e, group) => {
    Misc.ignoreDefault(e);
    this.props.selectFeatureGroup(group);
  }

  isFeatureChecked = (featureId) => {
    return (this.props.checkedFeatures.indexOf(featureId) >= 0);
  }

  getFeatureName = (featureName) => {
    var nameParts = namify(featureName);
    return Misc.toTitleCase(nameParts[nameParts.length - 1]);
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
const FeatureSelection = connector(featureSelection);
const FeatureSelectionHeader = connector(featureSelectionHeader);
const FeatureSelectionSubHeader = connector(featureSelectionSubHeader);
const FeatureSelectionFooter = connector(featureSelectionFooter);

export { FeatureSelection, FeatureSelectionHeader, FeatureSelectionSubHeader, FeatureSelectionFooter };
